import gql from 'graphql-tag';

export default gql`
    query GetFieldOpBoxes($jobId: Int) {
        getFieldOpBoxes(jobId: $jobId) {
            boxDetails {
                boxId
                boxDesc
                doNotUse
            }
        }
    }
`;
